import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  static readonly DEVICE_UUID = 'device.uuid';
  static readonly AUTH_USER_INFO = 'auth.userInfo';
  static readonly AUTH_CURRENT_USER = 'auth.currentUser';
  static readonly PREFERENCES_SIDE_MENU_IS_COLLAPSED = 'preferences.side-menu.is-collapsed';
  static readonly PREFERENCES_LANGUAGE = 'preferences.language';
  static readonly LAST_UNAUTHETNICATED_ROUTE = 'last.unauthenticated.route';
  static readonly APP_CONFIG_LAYOUT = 'app.config.layout';
  static readonly APP_CURRENT_VERSION = 'app.currentVersion';
  static readonly APP_FILTERS = 'app.filters.v3';
  static readonly APP_SORT = 'app.sort.v3';
  static readonly APP_COLUMNS = 'app.columns.v3';
  static readonly APP_PAGE_SIZE = 'app.pageSize.v1';
  static readonly APP_CURRENT_PAGE = 'app.currentPage.v1';
  static readonly MENU_COMPANY_CARD_COLLAPSE_STATE = 'company_card_collapse_state';
  static readonly APP_LAYOUT_CONFIG = 'app.config.layout.v2';
  static readonly APP_MENU_EXPANDED_ITEMS = 'app.menu.expanded-items';
  static readonly PROJECT_DASHBOARD_DATE_RANGE = 'project.dashboardDateRange';
  static readonly PROJECT_COST_ESTIMATE_COLUMNS = 'project.costEstimate.columns';
  static readonly PROJECT_TIME_TRACKER_FILTERS = 'project.timeTracker.filters';
  static readonly PROJECT_PROGRESS_FILTERS = 'project.progress.filters';
  static readonly CUSTOMERS_INFO_POPUP_DISMISSED = 'masterData.customers.infoPopup.dismissed';
  static readonly CHATBOT_TOGGLE_POSITION = 'chatbot.togglePosition';

  store(key: string, value: unknown) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  load(key: string) {
    const valueString = localStorage.getItem(key);
    if (valueString) {
      return JSON.parse(valueString);
    }
    return null;
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }
}
